import { render, staticRenderFns } from "./PartnersHeader.vue?vue&type=template&id=1a96b960&scoped=true&"
import script from "./PartnersHeader.vue?vue&type=script&lang=ts&"
export * from "./PartnersHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PartnersHeader.vue?vue&type=style&index=0&id=1a96b960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a96b960",
  null
  
)

export default component.exports